import { useRef, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { FileSpreadsheet, Loader2 } from "lucide-react";

// Re-upload the "Clinq Funder Match" workbook that drives the direct-pathway matcher.
export const FunderMatchImportCard = () => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState(null);
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post("/admin/funder-match/import", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setLast(data);
      toast.success(`Imported ${data.imported} funders (${data.active} active) — matching rules updated`);
    } catch (e) { toast.error(e.response?.data?.detail || "Import failed"); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <div className="mt-6 rounded-xl border border-[#0A8B85]/40 bg-[#0A8B85]/5 p-4" data-testid="funder-match-import">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-start gap-3">
          <FileSpreadsheet size={20} className="mt-0.5 text-[#5fd3cc]" />
          <div>
            <p className="text-sm font-bold text-white">Direct-pathway matching workbook</p>
            <p className="text-xs text-neutral-400">Upload the <b>Clinq Funder Match</b> .xlsx (Funders + Matching Rules sheets). Replaces the matching table and weights used on the founder "Apply to a Funder" page.</p>
            {last && <p className="mt-1 text-xs text-[#5fd3cc]" data-testid="funder-match-import-result">Last import: {last.imported} funders · {last.active} active · min CRS {last.config?.min_crs} · unlock KES {last.config?.unlock_price_kes}</p>}
          </div>
        </div>
        <label className="inline-flex cursor-pointer items-center gap-1.5 rounded-lg bg-[#0A8B85] px-3 py-2 text-sm font-semibold text-white hover:bg-[#097a74]">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <FileSpreadsheet size={14} />} {busy ? "Importing…" : "Upload workbook"}
          <input ref={ref} type="file" accept=".xlsx" className="hidden" disabled={busy} onChange={(e) => upload(e.target.files?.[0])} data-testid="funder-match-import-file" />
        </label>
      </div>
    </div>
  );
};
